import { type ReactElement } from 'react'
import { useTranslation } from '@front/model'
import { Link, type LinkProps } from '@tanstack/react-router'
import { TButton, type TButtonProps } from './button'

type Props = Omit<TButtonProps, 'leftSection' | 'icon' | 'component'> & LinkProps

export const ButtonExternal = ({ children, ...props }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <TButton component={Link} icon='open_in_new' variant={props.variant ?? 'ghost'} {...props}>
      {children || t('External Link')}
    </TButton>
  )
}
